import React, { Component } from "react";


class InstructorToolTip extends Component {
  
  constructor(props) {
		super(props);
		this.state={}
	}
	
	render() {
		return (
			<div className="instructorToolTip" >{this.props.state.toolTipText}</div>
	)}
}
export default InstructorToolTip;
